import { UTSLocale, Contacts } from "@smile2impress/attraction-constants";

export default {
    phone: {
        ...Contacts.phone,
    },
    phoneMedicare: {
        ...Contacts.phoneMedicare,
    },
    whatsappMedicare: {
        ...Contacts.whatsappMedicare,
    },
    emailMedicare: {
        ...Contacts.emailMedicare,
    },
    email: {
        ...Contacts.email,
    },
    emailPress: {
        link: "marketing@smile2impress.com",
    },
    whatsapp: {
        ...Contacts.whatsapp,
    },
    telegram: {
        ...Contacts.telegram,
    },
    facebook: {
        ...Contacts.facebook,
    },
    instagram: {
        ...Contacts.instagram,
    },
    tiktok: {
        ...Contacts.tiktok,
    },
    linkdin: {
        ...Contacts.linkdin,
    },
    trustpilot: {
        ...Contacts.trustpilot,
    },
    helpCenter: {
        [UTSLocale.SPAIN_ES]: {
            link: `${process.env.PERSONAL_AREA_URL}/faq?country=ESP`,
        },
        [UTSLocale.ITALY_IT]: {
            link: `${process.env.PERSONAL_AREA_URL}/faq?country=ITA`,
        },
        [UTSLocale.PORTUGAL_PT]: {
            link: `${process.env.PERSONAL_AREA_URL}/faq?country=PRT`,
        },
        [UTSLocale.FRANCE_FR]: {
            link: `${process.env.PERSONAL_AREA_URL}/faq?country=FRA`,
        },
        [UTSLocale.GB_EN]: {
            link: `${process.env.PERSONAL_AREA_URL}/faq?country=GBR`,
        },
        [UTSLocale.UKRAINE_UK]: {
            link: `${process.env.PERSONAL_AREA_URL}/faq?country=UKR`,
        },
        [UTSLocale.US_EN]: {
            link: `${process.env.PERSONAL_AREA_URL}/faq?country=USA`,
        },
        [UTSLocale.NL_NL]: {
            link: "https://drsmile.nl/faq/",
        },
        [UTSLocale.GERMANY_DE]: {
            link: "https://drsmile.de/faq/",
        },
        [UTSLocale.SWEDEN_SE]: {
            link: "https://drsmile.se/faq/",
        },
        [UTSLocale.DENMARK_DK]: {
            link: "https://drsmile.se/faq/", // TODO AD-2185: DK-specific contacts, reusing SE
        },
    },
};
